import React from 'react';
import { MUTED } from '../surface';

/**
 * "Couldn't load", in place of an empty state.
 *
 * The club page's loaders all read `if (r.success) setX(...)` with no else, so a failed request
 * left the state at its initial `[]` and the panel rendered its empty copy. A 500 and an empty
 * club were indistinguishable on screen — which is how a LIVE PORTALS panel spent its time
 * telling members to send the first Portal while the rail beside it showed one.
 *
 * Empty is a fact about the club. This is a fact about the request, and it says so.
 */
export default function LoadFailed({ what = 'this', onRetry, align = 'left', testId = 'load-failed' }) {
  return (
    <p
      className="m-0 font-mono"
      style={{ fontSize: 12, color: MUTED, lineHeight: 1.55, textAlign: align }}
      data-testid={testId}
      role="status"
    >
      {`Couldn't load ${what}. `}
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="underline"
          style={{ fontSize: 12, color: MUTED, letterSpacing: '0.05em' }}
          data-testid={`${testId}-retry`}
        >
          TRY AGAIN
        </button>
      )}
    </p>
  );
}
